import { KIT } from "@/constants/testIds";
import { ProgressRing } from "./ProgressRing";

/** Counts motivate more than percentages, so we show both. */
export const MealProgress = ({ done = 0, total = 0, title = "Today's meals", unit = "Meals", note, size = 76 }) => {
  const percent = total ? (done / total) * 100 : 0;
  return (
    <div data-testid={KIT.mealProgress} className="flex items-center gap-5 sm:gap-6">
      <ProgressRing value={percent} size={size} />
      <div className="min-w-0 flex-1">
        <h2 className="font-display text-xl font-semibold text-brand-teal sm:text-2xl">{title}</h2>
        <p className="mt-1 text-sm font-semibold text-brand-green">
          {done}/{total} {unit} Completed
          <span className="ml-2 font-normal text-muted-foreground">{Math.round(percent)}%</span>
        </p>
        {note && <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">{note}</p>}
      </div>
    </div>
  );
};
